import React, { useEffect, useRef, useState } from "react";
import { MandatoryStar, getSnackbarSuccess } from "../../../Utils/helper";
import { useDispatch } from "react-redux";
import {
  GetFinanceQcAction,
  PayoutDicountEditByFinance,
} from "../../../redux/actions/PayoutAction";
import { number } from "yup";

export const FinanceQCPopupEditDiscount = ({
  setIsEdit,
  isEdit,
  searchFilter,
  setPayabelData,
  reCallApi,
  setReCallApi,
  rowData,
  setRowData,
  firstPageData,
}) => {
  const ref = useRef();
  const [data, setData] = useState(null);
  const dispatch = useDispatch();

  // console.log("isEdit For testing", isEdit);

  const handleChange = (name, value) => {
    // console.log("name11", name);
    // console.log("value11", value);
    if (name === "discountType") {
      if (value === "") {
        // Reset everything when "Select Type" is chosen
        setData({
          ...data,
          discountType: "",
          discountAmount: "",
          discountedAmount: "",
          netAmount: "",
        });
      } else if (value === "Percentage" || value === "Amount") {
        // Reset discountAmount & discountedAmount only if Percentage is selected
        setData({
          ...data,
          discountType: value,
          discountAmount: "",
          discountedAmount: "",
          netAmount: "",
        });
      } else {
        // If Amount is selected, keep existing values
        setData({
          ...data,
          discountType: value,
        });
      }
    } else {
      setData({ ...data, [name]: value });
    }
  };
  useEffect(() => {
    setData({
      businessType: isEdit?.data?.buType,
      totalAmount: isEdit?.data?.totalAmount,
      requestID: isEdit?.data?.requestID,
      providerId: isEdit?.data?.providerId,
      remarks: isEdit?.data?.remarks,
      discountAmount: isEdit?.data?.discountAmount ?? "",
      discountedAmount: isEdit?.data?.discountedAmount ?? "",
      discountType: isEdit?.data?.discountType ?? "",
      mbg: isEdit?.data?.mbg ?? "",
      mis: isEdit?.data?.mis ?? "",
      netAmount: isEdit?.data?.netAmount,
      appointmentsDiscount: isEdit?.data?.appointmentsDiscount ?? "",
    });
  }, [isEdit]);

  const handleSubmit = (event) => {
    event?.preventDefault();
    console.log("data For Provider Wise", data);

    if (!data?.totalAmount) {
      alert("Please fill provider amount.");
      return;
    }
    if (!data?.remarks) {
      alert("Please fill remarks.");
      return;
    }
    if (
      data?.discountType !== "" &&
      (data?.discountAmount === null || data?.discountAmount === "")
    ) {
      alert("Please fill discount amount/percentage.");
      return;
    }

    console.log("Updated Data Before Submission for Provider Wise:", data);

    const res = dispatch(PayoutDicountEditByFinance(data));
    if (res) {
      getSnackbarSuccess("success", res?.data?.message, dispatch);
      setTimeout(() => {
        //dispatch(GetFinanceQcAction(searchFilter));
        if (reCallApi === true) {
          dispatch(
            GetFinanceQcAction({
              ...searchFilter,
              sessionId: rowData?.sessionID,
              ticketId: rowData?.requestID,
              providerId: rowData?.providerId,
            })
          );
        } else {
          dispatch(
            GetFinanceQcAction({
              ...searchFilter,
              sessionId: firstPageData?.sessionID,
              ticketId: firstPageData?.requestID,
              providerId: firstPageData?.providerId,
            })
          );
        }
      }, 2000); // 2-second delay
      setPayabelData([]);
      handleClose();
    }
  };

  const handleClose = () => {
    setIsEdit({ data: null, open: false });
    setPayabelData([]);
  };
  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black ">Update Payable</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => handleClose()}
        ></button>
      </div>

      {/* <form
        ref={ref}
        className="form-admin"
        style={{ overflowX: "hidden" }}
        onSubmit={handleSubmit}
        noValidate
      > */}
      <div className="modal-body addusermodalbox">
        <div className="row">
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">Request ID</label>
            <input
              name="requestID"
              type="text"
              disabled={true}
              value={data?.requestID}
              placeholder="Enter Here..."
              className="form-control form-select-admin inputbgavanish"
              required
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">Provider Name</label>
            <input
              name="providerName"
              type="text"
              disabled={true}
              value={isEdit?.data?.providerName}
              placeholder="Enter Here..."
              className="form-control form-select-admin inputbgavanish"
              required
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">
              Provider Amount
              {/* <MandatoryStar /> */}
            </label>
            <input
              name="totalAmount"
              type="text"
              placeholder="Enter Here..."
              value={data?.totalAmount}
              disabled
              min={1}
              className="form-control form-select-admin inputbgavanish"
              required
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">
              MBG
              {/* <MandatoryStar /> */}
            </label>
            <input
              name="discountAmountPercentage"
              type="number"
              value={data?.mbg}
              className="form-control form-select-admin inputbgavanish"
              onKeyDown={(e) => {
                const currentValue = e.target.value;

                // Get the key that is being pressed
                const keyPressed = e.key;

                // Predict the new value after the key press
                let newValue = currentValue;
                if (!isNaN(keyPressed) || keyPressed === ".") {
                  newValue = currentValue + keyPressed;
                } else if (keyPressed === "Backspace") {
                  newValue = currentValue.slice(0, -1);
                }
                if (Number(newValue) < Number(data?.totalAmount)) {
                  console.log("mbg for testing current", newValue);
                  console.log(
                    "data.netAmount testing for current",
                    data.netAmount
                  );
                  data.netAmount = (
                    Number(data?.totalAmount) +
                    Number(data?.mis) -
                    data?.appointmentsDiscount
                  ).toString();
                } else {
                  console.log("mbg for testing current1", newValue);
                  console.log(
                    "data.netAmount testing for current1",
                    data.netAmount
                  );
                  data.netAmount = (
                    Number(newValue) +
                    Number(data?.mis) -
                    data?.appointmentsDiscount
                  ).toString();
                }
              }}
              onChange={(e) => {
                handleChange("mbg", e.target.value);
              }}
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">
              Miscellaneous Charges
              {/* <MandatoryStar /> */}
            </label>
            <input
              name="discountAmountPercentage"
              type="number"
              value={data?.mis}
              className="form-control form-select-admin inputbgavanish"
              onChange={(e) => {
                if (Number(data?.mbg) < Number(data?.totalAmount)) {
                  data.netAmount = (
                    Number(data?.totalAmount) +
                    Number(e.target.value.trim()) -
                    data?.discountedAmount -
                    data?.appointmentsDiscount
                  ).toString();
                } else {
                  data.netAmount = (
                    Number(data?.mbg) +
                    Number(e.target.value.trim()) -
                    Number(data?.discountedAmount) -
                    Number(data?.appointmentsDiscount)
                  ).toFixed(2);
                }

                handleChange("mis", e.target.value);
              }}
            />
          </div>

          <div className="col-lg- 4 col-md-4">
            <label className="col-form-label">Discount Type</label>
            {/* <MandatoryStar /> */}
            <select
              name="DiscountType"
              className="form-select"
              style={{ height: "40px" }}
              required
              value={data?.discountType}
              onChange={(e) => handleChange("discountType", e.target.value)}
            >
              <option value="">Select Type</option>
              <option value="Amount">Amount</option>
              <option value="Percentage">Percentage</option>
            </select>
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">
              Discount Amount/Percentage
              {/* <MandatoryStar /> */}
            </label>
            <input
              name="discountAmountPercentage"
              type="number"
              min={0}
              onKeyPress={(e) => {
                const value = e.target.value;
                const allowedChars = /^[0-9\b.]+$/;
                if (!allowedChars.test(e.key)) {
                  e.preventDefault();
                }
                // Check if the input already contains a decimal point
                if (e.key === "." && value.includes(".")) {
                  e.preventDefault();
                }
                // Check if the input is going to exceed two decimal places
                if (
                  value.includes(".") &&
                  value.split(".")[1].length >= 2 &&
                  e.key !== "Backspace"
                ) {
                  e.preventDefault();
                }
              }}
              value={data?.discountAmount}
              placeholder="Enter Here..."
              className="form-control form-select-admin inputbgavanish"
              required
              disabled={data?.discountType === ""}
              onChange={(e) => {
                if (data?.discountType === "Percentage") {
                  // Calculate percentage-based discount

                  if (Number(data?.mbg) < Number(data?.totalAmount)) {
                    // data.discountedAmount = (
                    //   (Number(data?.netAmount) *
                    //     Number(e.target.value.trim())) /
                    //   100
                    // ).toString();

                    let netAmount =
                      Number(data?.totalAmount) + Number(data?.mis);

                    // console.log("netamt", netAmount);

                    let netAmountAfterTds =
                      Number(netAmount) -
                      (netAmount * Number(e.target.value.trim())) / 100;

                    data.discountedAmount = (
                      (netAmount * Number(e.target.value.trim())) /
                      100
                    ).toString();

                    // console.log(
                    //   "discount amount",
                    //   (netAmount * Number(e.target.value.trim())) / 100
                    // );

                    let finalAmount =
                      Number(netAmountAfterTds) -
                      Number(data?.appointmentsDiscount);

                    // console.log("netAmountAfterDis", netAmountAfterTds);
                    // console.log("finalAmount", finalAmount);

                    data.netAmount = finalAmount.toFixed(2);
                  } else {
                    data.discountedAmount = (
                      ((Number(data?.mbg) + Number(data?.mis)) *
                        Number(e.target.value.trim())) /
                      100
                    ).toString();

                    data.netAmount = (
                      Number(data?.mbg) +
                      Number(data?.mis) -
                      data?.discountedAmount -
                      data?.appointmentsDiscount
                    ).toFixed(2);
                  }
                } else if (data?.discountType === "Amount") {
                  // Directly assign the amount discount

                  if (Number(data?.mbg) < Number(data?.totalAmount)) {
                    data.discountedAmount = e.target.value;

                    data.netAmount = (
                      Number(data?.totalAmount) +
                      Number(data?.mis) -
                      Number(e.target.value) -
                      data?.appointmentsDiscount
                    ).toFixed(2);
                  } else {
                    data.discountedAmount = e.target.value;

                    data.netAmount = (
                      Number(data?.mbg) +
                      Number(data?.mis) -
                      Number(e.target.value) -
                      data?.appointmentsDiscount
                    ).toFixed(2);
                  }
                }
                handleChange("discountAmount", e.target.value);
              }}
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">
              Discounted Amount
              {/* <MandatoryStar /> */}
            </label>
            <input
              name="discountAmountPercentage"
              type="number"
              value={data?.discountedAmount}
              disabled
              className="form-control form-select-admin inputbgavanish"
              onChange={(e) => {
                handleChange("discountedAmount", e.target.value);
              }}
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">Appointments Discount</label>
            <input
              name="netAmount"
              type="number"
              disabled={true}
              value={data?.appointmentsDiscount}
              placeholder="Enter Here..."
              className="form-control form-select-admin inputbgavanish"
              required
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">Net Amount</label>
            <input
              name="netAmount"
              type="number"
              disabled={true}
              value={data?.netAmount}
              placeholder="Enter Here..."
              className="form-control form-select-admin inputbgavanish"
              required
            />
          </div>
          <div className="col-lg-12 col-md-12 mt-2">
            <label className="col-form-label">
              Remarks
              <MandatoryStar />
            </label>
            <textarea
              required
              className="form-control form-select-admin inputbgavanish"
              rows="5"
              cols="33"
              value={data?.remarks}
              onKeyPress={(e) => {
                const re = /^[a-zA-Z\s]*$/;
                if (e.target.value.trim() === "" && e.key === " ") {
                  e.preventDefault();
                  return;
                }
              }}
              onChange={(e) => handleChange("remarks", e.target.value)}
            ></textarea>
          </div>
        </div>
      </div>

      <div className="modal-footer modal-footer-admin  bottom-0  mt-4">
        <div className="d-flex justify-content-end flex-wrap gap-10">
          <button
            onClick={() => handleClose()}
            type="btn"
            className="savedetails"
          >
            Cancel
          </button>
          <button
            type="btn"
            className="savedetails"
            onClick={() => handleSubmit()}
          >
            Update
            {/* {"Update"} */}
          </button>
        </div>
      </div>
      {/* </form> */}
    </>
  );
};
